// extracted by mini-css-extract-plugin
export default {"container":"_1hOrm","iconX":"_1Wyan","closeButtonX":"_1Ut9e"};